import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { OAuthService } from 'angular-oauth2-oidc';
import { RootState } from '@root/app.state';

import * as PlatformActions from '@platform/platform.actions';
import { go } from '@platform/router.actions';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  standalone: false,
})
export class CallbackComponent implements OnInit {
  constructor(
    private oauthService: OAuthService,
    private store$: Store<RootState>,
  ) {}

  private static getCustomHashFragment(url: URL): string {
    if (url.hash) {
      return url.hash;
    }

    // Netscaler redirects to callback with search parameters, however, the OAuthService requires a hash as first character
    // We also dont remove the question mark because the OAuthService handles it and would work incorrectly if the url in the state parameter contains search parameters
    if (url.search) {
      return `#${encodeURIComponent(url.search)}`;
    }

    return '';
  }

  async ngOnInit(): Promise<void> {
    const currentUrl = new URL(window.location.href);
    const customHashFragment = CallbackComponent.getCustomHashFragment(currentUrl);
    await this.oauthService.tryLogin({
      customHashFragment,
      preventClearHashAfterLogin: true,
    });

    const identityClaims = this.oauthService.getIdentityClaims();
    this.store$.dispatch(PlatformActions.setIdentityClaims({ identityClaims }));

    const redirectUrl = new URL(this.oauthService.state ?? '', currentUrl.origin);
    const path = redirectUrl.pathname === '/' ? [''] : decodeURIComponent(redirectUrl.pathname).split('/');
    const query = Object.fromEntries(redirectUrl.searchParams.entries());
    this.store$.dispatch(go({ path, query }));
  }
}
